import * as React from 'react'
import { inject, observer } from 'mobx-react'

import AddToCart from 'src/components/Product/AddToCart/AddToCart'
import Image from 'src/components/UI/Image/Image'
import ProductLink from 'src/components/Product/ProductLink/ProductLink'
import { getLocalizedProductData, getPrice } from 'src/utils/product'

import styles from './ListProduct.module.scss'

type Props = {
  cart?: any
  product: any
  preview?: any
  locale: string
}

@inject('cart')
@inject('preview')
@observer
export default class ListProduct extends React.Component<Props> {
  render(): JSX.Element {
    let { product, preview, locale, cart } = this.props
    if (preview.previewProducts) {
      product = preview.getCurrentProductContext(product.product)
    }
    const { name, infoColorSwatch } = getLocalizedProductData(product, locale)

    const image =
      product.media && product.media.length > 0 ? product.media[0] : null
    const variant =
      product && product.items && product.items.length === 1
        ? product.items[0]
        : null
    const price =
      product && product.markets && cart && cart.country
        ? getPrice(product.markets, cart.country)
        : ''

    const color = infoColorSwatch ? infoColorSwatch.display_name : ''
    return (
      <ProductLink product={product} className={styles.listProduct}>
        <div className={styles.imageWrapper}>
          {image && (
            <Image
              className={styles.image}
              src={image.sources.full.url}
              alt={name}
              sizes={{
                mobile: '50vw',
                tablet: '50vw',
                desktop: '25vw',
              }}
            />
          )}
          <div className={styles.hoverContainer}>
            {variant && <AddToCart variant={variant} />}
          </div>
        </div>
        <div className={styles.productInfo}>
          <p>
            {name} {color}
          </p>
          <p className={styles.price}>{price ? price.price : ''}</p>
        </div>
      </ProductLink>
    )
  }
}
